/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';

import { IMapContextMenuPermissions, GarminMarkerInfo, IMapContextMenuData } from '../../../core/models';

@Component({
  selector: 'fm-garmin-menu-container',
  templateUrl: './garmin-menu-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GarminMenuContainerComponent {
  @Input()
  public menuData: IMapContextMenuData<GarminMarkerInfo>;

  @Input()
  public userPermissions: IMapContextMenuPermissions;

  @Output()
  public closed: EventEmitter<void> = new EventEmitter();

  @Output()
  public findNearestClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public zoomToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public streetViewClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public createGeofenceClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public dispatchWindowClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public viewStatusHistoryClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionFromClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public copyCoordinatesClicked: EventEmitter<string> = new EventEmitter();

  public onMenuClosed(): void {
    this.closed.emit();
  }

  public onFindNearestClicked(): void {
    this.findNearestClicked.emit();
    this.closed.emit();
  }

  public onZoomToClicked(): void {
    this.zoomToClicked.emit();
    this.closed.emit();
  }

  public onStreetViewClicked(): void {
    if (this.menuData.streetViewAvailable) {
      this.streetViewClicked.emit();
      this.closed.emit();
    }
  }

  public onCreateGeofenceClicked(): void {
    this.createGeofenceClicked.emit();
    this.closed.emit();
  }

  public onDispatchWindow(): void {
    this.dispatchWindowClicked.emit();
    this.closed.emit();
  }

  public onViewStatusHistory(): void {
    this.viewStatusHistoryClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionToClicked(): void {
    this.getDirectionToClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionFromClicked(): void {
    this.getDirectionFromClicked.emit();
    this.closed.emit();
  }

  public onCopyCoordinates(coordinatesToCopy: string): void {
    this.copyCoordinatesClicked.emit(coordinatesToCopy);
  }
}
